<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">신용카드</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">결제금액</span>
        <div class="ip-row">
          <label for="payAmount">결제금액</label>
          <input
            type="text"
            class="ip-comm"
            id="payAmount"
            :readonly="isProdPay"
            :value="
              (isProdPay
                ? prodAmount
                : cardTotalUprc > 0
                ? cardTotalUprc
                : complexUprc > 0
                ? complexUprc
                : dutchUprc > 0
                ? dutchUprc
                : totalCash
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
          />
        </div>
      </div>
      <div class="fieldset">
        <span class="h2">결제입력</span>
        <div class="ip-row">
          <label for="payCardNum">카드번호</label>
          <input
            type="text"
            class="ip-comm in-has-btn center"
            id="payCardNum"
            value="6243 3105 6040 3343"
          />
        </div>
        <div class="ip-row">
          <label for="payInstall">할부개월</label>
          <input
            type="text"
            class="ip-comm in-has-btn center"
            id="payInstall"
            value="1"
          />
        </div>
        <button
          type="button"
          class="btn-square btn-main"
          @click="$.emit('keypad')"
        >
          멀티<br />패드<span class="overlay"></span>
        </button>
      </div>
      <div class="fieldset">
        <span class="h2">서명</span>
        <div class="ip-row">
          <canvas id="signarea" class="sign-area"></canvas>
          <button type="button" class="btn-2xlg btn-yellow" @click="payInCard">
            승인요청<span class="overlay"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 아래 요소 내 버튼들은 기본 우측 정렬, 좌측 정렬은 al-left 클래스 추가 -->
    <div class="pop-btn-area al-left">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-fourth btn-lblue"
        @click="payInRegist"
      >
        임의등록<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardPayment",
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    payType: String,
    isComplex: Boolean,
    cardTotalUprc: Number,
    complexUprc: Number,
    dutchUprc: Number,
    isDutchPayment: Boolean,
    isProdPay: Boolean,
    prodAmount: Number,
  },
  data() {
    return {
      totalCash: this.totalUprc - this.totalDiscount - this.receivedUprc,
    };
  },
  methods: {
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    async payInCard() {
      let payAmount = parseInt(
        document.getElementById("payAmount").value.replace(",", "")
      );

      if (this.isComplex) {
        this.$.emit("close");
        this.$.emit("closeComplexCard", payAmount);
        this.$.emit("addComplexPayArr", payAmount, "card");
      } else if (this.isDutchPayment) {
        this.$.emit("close");
        this.$.emit("closeDutchCard", payAmount);
      } else {
        await this.loadingPromise("결제완료 처리 중입니다.");
        await this.loadingPromise("영수증 출력 중입니다.");
        this.$.emit("resetBasket", this.payType);
        this.$.emit("close");
      }
    },
    async payInRegist() {
      await this.loadingPromise("임의등록 처리 중입니다.");
      await this.loadingPromise("영수증 출력 중입니다.");
      this.$.emit("resetBasket", this.payType);
      this.$.emit("close");
    },
    userSign() {
      // 캔버스 요소와 2D 컨텍스트 가져오기
      const canvas = document.getElementById("signarea");
      const ctx = canvas.getContext("2d");

      // 마우스 이벤트 처리
      let isDrawing = false;

      canvas.addEventListener("mousedown", (e) => {
        isDrawing = true;
        ctx.beginPath();
        ctx.moveTo(e.offsetX, e.offsetY);
      });

      canvas.addEventListener("mousemove", (e) => {
        if (isDrawing) {
          ctx.lineTo(e.offsetX, e.offsetY);
          ctx.stroke();
        }
      });

      canvas.addEventListener("mouseup", () => {
        isDrawing = false;
      });

      canvas.addEventListener("mouseout", () => {
        isDrawing = false;
      });
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.userSign();
  },
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
canvas {
  border: 1px solid #000;
}
</style>


